<template>
	<AppDialog ref="dialog_container" dialogName="DeleteBlockDialog">
		<div class="delete-block-dialog">
			<div class="dialog-title flex-centerize text-align-center mt-4">
				Are you sure you want to<br />
				delete this API doc?
			</div>
			<div class="dialog-bottom flex-centerize">
				<CancelButton class="mr-3" @click="close">Cancel</CancelButton>
				<DangerButton @click="deleteApiDoc"> Delete </DangerButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import { deleteNode } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'DeleteApiDocDialog',
	components: { AppDialog },
	props: { dialogPromiseHandlers: { type: Object } },
	methods: {
		...mapActionsShorthand({ deleteNode }),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		async deleteApiDoc() {
			this.dialogPromiseHandlers.resolve(true);
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.delete-block-dialog {
	border-radius: 15px !important;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16) !important;

	::v-deep(.widget-preview) {
		min-height: 350px !important;
	}
}
</style>
